document.addEventListener("DOMContentLoaded", function () {
  let slideshows = document.querySelectorAll('[data-slider]');

  slideshows.forEach(function (slider) {
    // If Swiper is available (used in most Shopify themes)
    if (slider && slider.swiper) {
      slider.swiper.params.loop = true;
      slider.swiper.params.autoplay = {
        delay: 3000, // 3 seconds
        disableOnInteraction: false, // don’t stop if user interacts
        pauseOnMouseEnter: false,    // don’t stop on hover
      };
      slider.swiper.loopCreate();
      slider.swiper.autoplay.start();
      slider.swiper.update();
    } 
    // Fallback for themes without Swiper
    else if (slider) {
      let slides = slider.querySelectorAll("li, .slideshow__slide, .slideshow-slide");
      let index = 0;

      if (slides.length > 0) {
        slides.forEach((s, i) => (s.style.display = i === 0 ? "block" : "none"));

        setInterval(() => {
          slides[index].style.display = "none";
          index = (index + 1) % slides.length;
          slides[index].style.display = "block";
        }, 3000); // 3 seconds
      }
    }
  });
});
